













import {
  Component, Prop,
  Vue,
} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class ClipboardSnackbar extends Vue {
  @Prop({default: false}) private open!: boolean;
  @Prop({default: ''}) private icon!: string;
  @Prop({default: ''}) private text!: string;



}
